import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ShieldAlert, X } from "lucide-react";

// Bandeau MODE SUPPORT PROGÈRE : affiché quand un technicien a un accès temporaire
// actif sur le compte de l'entreprise du client. Le client peut révoquer.
export function SupportAccessBanner() {
  const [sessions, setSessions] = useState([]);

  const load = useCallback(() => {
    api.get("/support/access-sessions/active").then(({ data }) => setSessions(data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const revoke = async (id) => {
    try { await api.post(`/support/access-sessions/${id}/revoke`); toast.success("Accès révoqué"); load(); }
    catch { toast.error("Erreur"); }
  };

  if (sessions.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="support-access-banner">
      {sessions.map((s) => (
        <div key={s.id} className="flex flex-wrap items-center gap-3 rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-2.5">
          <ShieldAlert className="w-5 h-5 text-red-400 shrink-0" />
          <div className="text-sm text-white min-w-0">
            <b className="text-red-300">MODE SUPPORT PROGÈRE</b> — {s.technician_name} consulte temporairement votre compte pour le billet <b className="font-mono">{s.ticket_ref}</b>.
            {s.reason && <span className="text-white/60"> Motif : {s.reason}.</span>}
            <span className="text-white/40"> Expire : {new Date(s.expires_at).toLocaleTimeString("fr-CA")}</span>
          </div>
          <button onClick={() => revoke(s.id)} data-testid={`revoke-access-${s.id}`}
            className="ml-auto flex items-center gap-1.5 rounded-md border border-red-400/40 px-3 py-1 text-xs font-semibold text-red-300 hover:bg-red-500/15">
            <X className="w-3.5 h-3.5" /> Révoquer l'accès
          </button>
        </div>
      ))}
    </div>
  );
}
